<template>
  <!-- 页脚本体 -->
  <!-- ❗只有top和bottom是满宽度容器，left、center、right是普通容器 -->
  <UFooter
    :ui="{
      root: 'bg-default text-muted w-full',
      // 主内容大容器
      container: 'flex-col',
      top: 'lg:py-0 py-0',
      // 底部红色容器
      bottom: 'lg:py-0 py-0 bg-secondary',
      // 主内容容器
      center: 'w-full lg:pt-32 lg:pb-8 flex flex-col',
      left: '',
      right: '',
    }"
  >
    <!-- 顶部插槽-满宽度 -->
    <template #top>
      <!-- 渐变条 -->
      <div :class="['h-(--gradient-line-height) w-full', 'bg_linear_to_r']" />
    </template>

    <!-- 默认插槽-非满宽度 -->
    <template #default>
      <!-- 顶层logo、导航大容器 -->
      <div :class="['w-full', 'flex lg:flex-row flex-col gap-x-20 gap-y-10']">
        <!-- 简介大容器 -->
        <div :class="['flex justify-center items-start flex-col', 'max-w-80', 'gap-4']">
          <!-- LOGO -->
          <NuxtImg
            :src="configSite.LOGO"
            class="lg:w-32 w-24 cursor-pointer"
            draggable="false"
            alt="Footer Logo"
            loading="lazy"
            @click="useLocalePush('/')"
          />
          <!-- 总部地址 -->
          <p>{{ officeDetails[0]?.address }}</p>

          <!-- 联系方式链接 -->
          <div v-for="item in contactSheet" :key="`contact-${item.label}`" class="flex gap-2">
            <UIcon :name="item.icon" :class="['lg:size-6 size-5']" />
            <p>{{ t(item.label) }}:</p>
            <ULink @click="item.value && useCopy(item.value)">
              {{ item.value }}
            </ULink>
          </div>

          <!-- 独立链接 -->
          <!-- 办事处 -->
          <div class="flex gap-2">
            <UIcon name="la:map-marked-alt" :class="['lg:size-6 size-5']" />
            <p>{{ t('footer.localOffice') }}:</p>
            <ULink @click="useLocalePush('/about/contact')">
              <p>{{ t('footer.viewLocation') }}</p>
            </ULink>
          </div>
        </div>

        <!-- 导航大容器 -->
        <div :class="['grid lg:grid-cols-4 grid-cols-1 lg:gap-12 gap-4', 'flex-1']">
          <!-- 单列容器，筛选掉“第一个数据体因为是首页 -->
          <div
            v-for="parent in appMenu.slice(1)"
            :key="`footer-appmenu-${parent.label}`"
            class="flex flex-col gap-2"
          >
            <!-- 分栏标题 -->
            <h2 :class="['lg:text-2xl text-xl font-bold uppercase']">
              {{ parent.label }}
            </h2>
            <USeparator :ui="{ border: ['my-1'] }" />
            <!-- 菜单单个链接 -->
            <ULink
              v-for="children in parent.children"
              :key="parent.label"
              :class="['flex items-center', 'lg:text-lg text-md text-start', 'group/footer-link']"
              @click="useLocalePush(children.to)"
            >
              <p :class="[]">{{ children.label }}</p>
              <!-- 动画箭头 -->
              <div :class="['group-hover/footer-link:block hidden']">
                <UIcon name="fe:arrow-right" />
              </div>
            </ULink>
          </div>
        </div>
      </div>
      <!-- 分隔线 -->
      <USeparator class="mt-10 mb-10 bg-red-200" />
      <!-- 社交行容器 -->
      <div :class="['w-full', 'flex justify-between items-center lg:flex-row flex-col gap-6']">
        <!-- 再次简介 -->
        <h3 :class="['font-bold text-lg capitalize']">{{ t('page.index.primary.subTitle') }}</h3>
        <!-- 社交链接容器 -->
        <div :class="['flex lg:gap-6 gap-4']">
          <ULink
            v-for="item in iconList"
            :key="item.icon"
            :to="item.href"
            target="_blank"
            :class="[
              'flex items-center justify-center',
              'text-3xl text-white hover:text-white',
              'size-10',
              'light:bg-zinc-300 dark:bg-gray-600',
              // 移除空格
              item.btnClass.replaceAll(' ', ''),
            ]"
          >
            <!-- 悬浮提示文字 -->
            <UTooltip
              :delay-duration="0"
              :content="{
                align: 'center',
                side: 'top',
                sideOffset: 8,
              }"
            >
              <UIcon :name="item.icon" />
              <template #content>
                <div :class="['flex flex-col justify-center items-center']">
                  <img
                    v-if="item.tipImg"
                    :src="item.tipImg"
                    :alt="`Tooltip Image-${item.tipText}`"
                    draggable="false"
                    :class="['size-32', 'object-cover']"
                  />
                  <p v-if="item.tipText">{{ t(item.tipText) }}</p>
                </div>
              </template>
            </UTooltip>
          </ULink>
        </div>
      </div>
    </template>

    <!-- 底部插槽-满宽度 -->
    <template #bottom>
      <!-- 隐私条款按钮组容器 -->
      <nav :class="['bg-primary']">
        <div :class="['page_view', 'flex lg:flex-row flex-col', 'm-0 p-0']">
          <VueBitsFlowingMenu
            v-for="(item, index) in footerList"
            :idx="index"
            :label="item.label"
            :action="item.action"
            :enable-marquee="false"
          />
        </div>
      </nav>
      <!-- 版权容器 -->
      <div
        :class="[
          'page_view',
          'flex items-center justify-center flex-col',
          'py-8 gap-y-4 text-white font-extralight',
        ]"
      >
        <!-- 版权信息容器 -->
        <div class="flex flex-col items-center justify-center lg:gap-2.5 gap-2 text-center">
          <ULink to="https://beian.miit.gov.cn" class="text-white" target="_blank">
            粤ICP备2021094049号-2
          </ULink>
          <p class="">
            {{ `© 1995-${new Date().getFullYear()} Crystal Network Logistics Ltd.` }}
          </p>
        </div>
      </div>
    </template>
  </UFooter>
</template>

<script lang="ts" setup>
  import type { AppComponentItem, MenuItemProps } from '~/types/common/item'
  import { useCookieModal } from '~/stores/useCookieDialog'

  const { t } = useI18n()
  /** 完整的顶栏菜单 */
  const { appMenu, policyMenu } = useConfigMenu()
  const { openModal } = useCookieModal()
  /** 办公室数据列表 */
  const { officeDetails } = useConfigMenu()
  const { configSite } = useConfigStatic()

  const appConfig = useRuntimeConfig().public

  const footerList: MenuItemProps[] = [
    ...policyMenu.map(item => ({
      label: item.label,
      action: () => {
        item.value && useLocalePush(item.value)
      },
    })),
    {
      label: 'dialog.cookie.title',
      action: () => openModal(),
    },
  ]

  /** 联系信息 */
  const contactSheet: AppComponentItem[] = [
    {
      id: 'telephone',
      icon: 'tabler:device-landline-phone',
      label: 'form.telephone',
      value: '+852-3128-7900',
    },
    {
      id: 'fax',
      icon: 'mdi:printer-outline',
      label: 'form.fax',
      value: '+852-2472-2735',
    },
  ]

  interface SocialItem {
    icon: string
    btnClass: string
    tipText: string
    tipImg?: string
    href?: string
  }

  /**​ 图标链接 */
  const iconList: SocialItem[] = [
    {
      icon: 'ic:baseline-wechat',
      btnClass: 'hover:bg-[rgb(20,196,104)]',
      tipText: 'footer.inWechat',
      tipImg: '/img/wechat/qr-official-account-258x258.webp',
      //  这里要加根域名前缀，否则nuxt的vue router会警告匹配不到该路由
      href: `${appConfig.siteUrl}/img/wechat/qr-official-account-258x258.webp`,
    },
    {
      icon: 'ic:baseline-facebook',
      btnClass: 'hover:bg-[rgb(9,101,254)]',
      tipText: 'footer.inFacebook',
      href: 'https://www.facebook.com/crystalnetworklogisticsthailand',
    },
    {
      icon: 'mdi:linkedin',
      btnClass: 'hover:bg-[rgb(10,102,194)]',
      tipText: 'footer.inLinkedin',
      href: 'https://www.linkedin.cn/incareer/company',
    },
  ]
</script>
